// Constants for different requests for current reducer
export default {
  auditLog: 'AUDIT_LOG',
  auditEvent: 'AUDIT_EVENT',
};
